import { Box } from '@mui/material';
import Sidebar from '../sidebar';
import { Outlet } from 'react-router-dom';
import TitleBar from '../title-bar';
import React from 'react';

const SidebarLayout = (): JSX.Element => {
  const [open, setOpen] = React.useState(true);

  const handleSetOpen = (value: boolean): void => {
    setOpen(value);
  };

  const handleDrawerOpen = (): void => {
    setOpen(!open);
  };

  return (
    <Box
      width={'100%'}
      sx={{
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <TitleBar handleDrawerOpen={handleDrawerOpen} />
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Sidebar open={open} setOpen={handleSetOpen} />
        <Box sx={{ flexGrow: 1 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default SidebarLayout;
